export default __webpack_public_path__ + "static/media/passport1.91caeb01.svg";